import { createTheme } from "@mui/material";

const materialTheme = createTheme({
  palette: {
    common: {
      black: "#000",
      white: "#fff",
    },
    primary: {
      main: "#0a474c",
    },
    secondary: {
      main: "#FFC107",
    },
  },
  typography: {
    fontFamily: "Inter",
    h1: {},
    h3: {
      fontSize: "20px",
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: 1.167,
      letterSpacing: "0em",
    },
    h4: {
      fontSize: "16px",
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: 1.235,
      letterSpacing: "0.00735em",
    },
    h5: {
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: 1.334,
      letterSpacing: "0em",
    },
    h6: {
      fontSize: "12px",
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: 1.6,
      letterSpacing: "0.0075em",
    },
    body1: {
      fontSize: "14px",
      fontFamily: "Inter",
      fontWeight: 400,
      lineHeight: 1.5,
      letterSpacing: "0.00938em",
    },
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});
export default materialTheme;
